export default __webpack_public_path__ + "static/manyavar-882126adfc434c062f357bc33cb9386e.jpg";